import * as React from "react";
import { casesActions } from "configs";
import { useDispatch, useOnline, useToast } from "duck";
import {
  CaseStatusEnum,
  MedicalCasesDocument,
  useUpdateMedicalCasesStatusMutation
} from "requests";
import { hooks, SelectionContext } from "../../../../../duck";

export const useUpdateStatus = (onSuccess: () => void) => {
  const online = useOnline();
  const dispatch = useDispatch();
  const { selection, reset } = React.useContext(SelectionContext);
  const toast = useToast();

  const variables = hooks.useListQueryVariables();
  const [update, { loading }] = useUpdateMedicalCasesStatusMutation({
    awaitRefetchQueries: true,
    refetchQueries: [{ query: MedicalCasesDocument, variables }]
  });

  return {
    loading,
    update: (status: CaseStatusEnum) => {
      const onlineIds = selection
        .filter(medCase => medCase.offlineStatus === "normal")
        .map(medCase => medCase._id);

      const allIds = selection.map(medCase => medCase._id);
      dispatch(casesActions.updateCasesStatus({ status, _ids: allIds }));

      const onlineUpdatePromise =
        onlineIds.length > 0 && online
          ? update({
              variables: {
                input: { ids: onlineIds, status }
              }
            }).then(() => {})
          : Promise.resolve();

      return onlineUpdatePromise
        .then(() => {
          onSuccess();
          toast({
            status: "success",
            description:
              selection.length > 1
                ? "Cases are updated successfully."
                : "Case is updated successfully."
          });
          reset();
        })
        .catch(() => {});
    }
  };
};
